import { render, staticRenderFns } from "./GaDateRange.vue?vue&type=template&id=327c0faa&scoped=true&"
import script from "./GaDateRange.vue?vue&type=script&lang=ts&"
export * from "./GaDateRange.vue?vue&type=script&lang=ts&"
import style0 from "./GaDateRange.vue?vue&type=style&index=0&id=327c0faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c0faa",
  null
  
)

export default component.exports